import AfterLoginMixin from './AfterLoginMixin.js'

export default {
    mixins: [AfterLoginMixin],
    methods: {
      cognitoRedirectingMixin: async function(cognitoResponse, email) {
        switch (cognitoResponse.nextStep.signInStep) {
          case 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED':
            window.tempCredentials = {
              username: email,
            };
            this.$router.push('/account/complete-password');
            break;
          // case 'CONFIRM_SIGN_IN_WITH_SMS_CODE':
          case 'CONFIRM_SIGN_IN_WITH_TOTP_CODE':
            window.tempCredentials = {
              username: email,
            };
            this.$router.push('/account/otp');
            break;
          case 'RESET_PASSWORD':
            this.$router.push(`/account/reset-password/${this.email}`);
            break;
          case 'DONE':
            delete window.tempCredentials;
            await this.afterLoginMixin();
            break;
          default:
            console.error("Invalid cognito next step!", cognitoResponse.nextStep.signInStep)
            break;
        }
      }
    }
}